import { useState } from 'react'
import { NewEventModal } from '../NewEventModal'

// QuickActions - three stacked buttons. "New event" is wired; the other two
// are stubs until briefings (spec 05) and reports (spec 07) ship.

export function QuickActions() {
  const [creating, setCreating] = useState(false)
  return (
    <div className="bg-white border border-line rounded">
      <div className="px-5 py-3 border-b border-line">
        <h2 className="font-display text-lg">Quick actions</h2>
      </div>
      <div className="p-4 space-y-2">
        <button
          type="button"
          onClick={() => setCreating(true)}
          className="w-full px-3 py-2.5 rounded text-sm font-semibold bg-green text-parchment hover:bg-green/90 transition-colors"
        >
          + New event
        </button>
        <button
          type="button"
          disabled
          title="Briefing packs land with the Briefings tab in a later phase."
          className="w-full px-3 py-2.5 rounded text-sm font-semibold border border-line text-ink-soft opacity-60 cursor-not-allowed"
        >
          Open today's briefing pack
        </button>
        <button
          type="button"
          disabled
          title="Weekly reports ship with Reports / PDF in a later phase."
          className="w-full px-3 py-2.5 rounded text-sm font-semibold border border-line text-ink-soft opacity-60 cursor-not-allowed"
        >
          Generate weekly report
        </button>
      </div>
      {creating && <NewEventModal onClose={() => setCreating(false)} />}
    </div>
  )
}
